import { Injectable } from '@angular/core';
import { MaintenanceMessage } from '../models/maintenance-message';
import { ApiBase } from '../models/api-base';
import { HttpParams, HttpContext } from '@angular/common/http';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceMessageApi extends ApiBase {
  override endpoint = 'maintenance';

  get(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    params?: HttpParams,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    context?: HttpContext
  ): Observable<MaintenanceMessage> {
    /*return this.httpClient.get<MaintenanceMessage>(this.url(), {
      params: params,
      context: context ? context : withStatusMessage(true, false),
    });*/

    /*return of({
      id: 0,
      start: '2026-03-13T13:55:46.000000Z',
      end: '2026-03-13T13:55:46.000000Z',
      start_show: '2026-03-13T13:55:46.000000Z',
      end_show: '2026-03-13T13:55:46.000000Z',
      message_de: 'message_de',
      message_it: 'message_it',
      message_fr: 'message_fr',
    } as MaintenanceMessage);*/
    return of(null as unknown as MaintenanceMessage);
  }
}
